import ActionType from "../../../isp._comun/reductores/ActionType";
export default class ActionTypeFact extends ActionType {}
